export const tagLabels = {
  // category
  "category:LP": { ja: "LP", en: "LP" },
  "category:EC": { ja: "ECサイト", en: "EC Website" },
  "category:Corporate": { ja: "コーポレートサイト", en: "Corporate Website" },
  "category:SNS": { ja: "SNS運用", en: "Social Media Marketing" },
  "category:Novelty": { ja: "ノベルティ", en: "Novelty" },
  "category:Uniform": { ja: "ユニフォーム", en: "Uniform" },
  "category:Character": { ja: "キャラクター", en: "Character" },
  "category:Product": { ja: "商品制作", en: "Product" },
  "category:Blog": { ja: "ブログ", en: "Blog" },
  "category:Display": { ja: "什器", en: "Display Fixture" },
  "category:Flyer": { ja: "チラシ", en: "Flyer" },
  "category:Banner": { ja: "バナー", en: "Banner" },
  "category:Movie": { ja: "動画", en: "Movie" },


  // company
  "companyCountry:japan": { ja: "日本", en: "Japan" },
  "companyCountry:germany": { ja: "ドイツ", en: "Germany" },
  "companyCountry:belgium": { ja: "ベルギー", en: "Belgium" },

  // target
  "targetRegion:europe": { ja: "ヨーロッパ全域", en: "All across Europe" },
  "targetCountry:germany": { ja: "ドイツ", en: "Germany" },
  "targetCountry:belgium": { ja: "ベルギー", en: "Belgium" },
  "targetCountry:japan": { ja: "日本", en: "Japan" },

  // industryTags
  food: { ja: "食品販売", en: "Food Sales" },
  noodles: { ja: "製麺", en: "Noodle Production" },
  restaurant: { ja: "飲食店", en: "Restaurant" },
  apparel: { ja: "アパレル", en: "Apparel" },
  goods: { ja: "雑貨販売", en: "General Goods Sales" },
  service: { ja: "サービス業", en: "Service Industry" },
  interior: { ja: "インテリア", en: "Interior" },
  artSales: { ja: "アート販売", en: "Art Sales" },
  event: { ja: "イベント運営", en: "Event Management" },
  sports: { ja: "スポーツチーム", en: "Sports Team" },
  tradingCard: { ja: "トレーディングカード販売", en: "Trading Card Sales" },
  webService: { ja: "Webコンテンツ", en: "Web Service" },
  it: { ja: "IT", en: "IT" },
  consulting: { ja: "コンサルティング", en: "Consulting" },
  pharmaceutical: { ja: "製薬", en: "Pharmaceutical" },


  // serviceTags
  translation: { ja: "翻訳", en: "Translation" },
  localization: { ja: "越境ローカライズ支援", en: "Cross-border Localization" },
  ec: { ja: "ECサイト", en: "EC Website" },
  shopify: { ja: "Shopify", en: "Shopify" },
  lp: { ja: "LP", en: "LP" },
  corporate: { ja: "コーポレートサイト", en: "Corporate Website" },
  emailSales: { ja: "メール営業支援", en: "Email Sales Support" },
  novelty: { ja: "ノベルティ", en: "Novelty" },
  uniform: { ja: "ユニフォーム制作", en: "Uniform Production" },
  character: { ja: "キャラクターデザイン", en: "Character Design" },
  sns: { ja: "SNS運用", en: "Social Media Marketing" },
  product: { ja: "商品制作", en: "Product Development" },
  blog: { ja: "ブログ", en: "Blog" },
  logo: { ja: "ロゴ制作", en: "Logo Design" },
  websiteRedesign: { ja: "サイト改修", en: "Website Redesign" },
  print: { ja: "プリント", en: "Print" },
  exhibitionAgency: { ja: "展示会・イベント出展代行", en: "Exhibition and event agent" },
  display: { ja: "什器作成", en: "Display fixture" },
  flyer: { ja: "チラシ作成", en: "Flyer" },
  banner: { ja: "バナー作成", en: "Banner" },
  movie: { ja: "動画制作", en: "Movie" },

  // purposeTags
  inquiry: { ja: "問い合わせ増加", en: "Increase in inquiries" },
  brand: { ja: "ブランド認知度向上・企業アピール", en: "Brand Awareness and Corporate Promotion" },
  sales: { ja: "販売促進", en: "Sales Promotion" },
  informationSharing: { ja: "情報発信", en: "Information sharing" },
};
